export interface Category {
  id: number;
  name: string;
  nameRu: string;
  url: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: 1,
    name: 'Shoes',
    nameRu: 'Обувь',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-run-line',
    description: 'Кроссовки, ботинки и кеды',
  },
  {
    id: 2,
    name: 'Hoodies/Sweaters',
    nameRu: 'Худи и свитеры',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Тёплые худи, свитшоты и толстовки',
  },
  {
    id: 3,
    name: 'T-Shirts',
    nameRu: 'Футболки',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-air-line',
    description: 'Базовые и дизайнерские футболки',
  },
  {
    id: 4,
    name: 'Jackets',
    nameRu: 'Куртки',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-t-shirt-2-line',
    description: 'Ветровки, бомберы и пуховики',
  },
  {
    id: 5,
    name: 'Pants/Shorts',
    nameRu: 'Штаны и шорты',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    description: 'Джинсы, брюки и шорты',
  },
  {
    id: 6,
    name: 'Headwear',
    nameRu: 'Головные уборы',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-capsule-line',
    description: 'Кепки, шапки и панамы',
  },
  {
    id: 7,
    name: 'Sets',
    nameRu: 'Комплекты',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    description: 'Готовые комплекты одежды',
  },
  {
    id: 8,
    name: 'Underwear/Underpants',
    nameRu: 'Нижнее бельё',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-shirt-line',
    description: 'Трусы, носки и базовое бельё',
  },
  {
    id: 9,
    name: 'Jersey',
    nameRu: 'Джерси',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
    description: 'Спортивные джерси и форма',
  },
  {
    id: 10,
    name: 'Accessories',
    nameRu: 'Аксессуары',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    description: 'Очки, часы и украшения',
  },
  {
    id: 11,
    name: 'Bags',
    nameRu: 'Сумки',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-shopping-bag-line',
    description: 'Рюкзаки, сумки и клатчи',
  },
  {
    id: 12,
    name: 'Belts',
    nameRu: 'Ремни',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    description: 'Кожаные ремни и аксессуары',
  },
  {
    id: 13,
    name: 'Perfumes',
    nameRu: 'Парфюмерия',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-contrast-drop-line',
    description: 'Духи и ароматы',
  },
  {
    id: 14,
    name: 'Other Stuff',
    nameRu: 'Прочее',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    description: 'Другие товары и аксессуары',
  },
];